import { EffectCallback, useEffect } from 'react';

/**
 * Hook to use when you want to execute only on mounting.
 * This will avoid eslint warnings when using an empty dependency array, and clearly states your intentions.
 */
export const useEffectOnMount = (effect: EffectCallback) => {
  useEffect(effect, []);
};
